import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { postUnmappedPlantsDataEndpoint } from '../../../common/endpoints';

export const postUnmappedPlantsData = createApi(postUnmappedPlantsDataEndpoint, 'POST');

const SaveUnmappedPlants = createSlice({
  name: 'SaveUnmappedPlants',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postUnmappedPlantsData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postUnmappedPlantsData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postUnmappedPlantsData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SaveUnmappedPlants.reducer;